import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "LineaInvestigacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "LineaInvestigacionPage",
            ss: ss,
            ajax: {
                "url": ss.indexLineaInvestigacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'LineaInvestigacion', name: 'LineaInvestigacion', title: 'Linea de Investigación' },
                { data: 'AreaInvestigacion', name: 'ai.AreaInvestigacion', title: 'Area de Investigación' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            areaInvestigaciones: [],

            lineaInvestigaciones:[],
            lineaInvestigacion: {},
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {

        getAreaInvestigacion() {
            this.ss.listAreaInvestigacion().then(
                (result) => {
                    let response = result.data;
                    this.areaInvestigaciones = response.data;
                }
            ).cath( error =>{
                console.log(error);
            });
        },
        newLineaInvestigacion() {
            this.lineaInvestigacion = {};
            this.$refs['frm-lineaInvestigacion'].show();
        },
        showLineaInvestigacion(id) {
            this.isLoading=true;
            this.ss.showLineaInvestigacion(id).then(
                (result) => {
                    let response = result.data;
                    this.lineaInvestigacion = response.data;
                    this.$refs['view-lineaInvestigacion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editLineaInvestigacion() {
            this.$refs['frm-lineaInvestigacion'].show();
            this.$refs['view-lineaInvestigacion'].hide();
        },
        cancelLineaInvestigacion() {
            if (this.lineaInvestigacion.id) {
                this.$refs['view-lineaInvestigacion'].show();
            }
            this.$refs['frm-lineaInvestigacion'].hide();
        },
        saveLineaInvestigacion() {
            this.ss.storeLineaInvestigacion(this.lineaInvestigacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-lineaInvestigacion'].hide();
                    this.$refs['datatable-lineaInvestigacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteLineaInvestigacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                        this.ss.destroyLineaInvestigacion(this.lineaInvestigacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-lineaInvestigacion'].hide();
                                this.$refs['datatable-lineaInvestigacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-LineaInvestigacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showLineaInvestigacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
            this.$router.push('/Login');
        } else {
           
            this.auth = usuario; 
            this.getAreaInvestigacion();
        }
    }
};
